export default "__VITE_ASSET__CshcbUbE__"